/**
 * Тестовый сервер (docs/deploy.md «Тестовый сервер»): та же сборка, но с VITE_KLICHAT_STAGE=staging.
 * На нём видна плашка «Тестовый сервер», к заголовку вкладки добавлено «Тест», а коды подтверждения
 * постоянные (VITE_TEST_CODE) — их подсказывает форма входа. На проде обе переменные пустые.
 */
export const isStaging = import.meta.env.VITE_KLICHAT_STAGE === 'staging'

/** Постоянный код подтверждения тестового сервера; пусто — обычные коды из SMS и писем. */
export const testCode = isStaging ? ((import.meta.env.VITE_TEST_CODE as string | undefined) ?? '') : ''

/** Заголовок вкладки без счётчика: на тестовом сервере — с пометкой, чтобы не спутать с настоящим. */
export const appTitle = isStaging ? 'Тест · Кличат' : 'Кличат'
